'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@/shared/components/ui';
import { TooltipLista } from '@/shared/components/ui/common/TooltipLista';
import type { TelefoneTag } from '../../utils/resolveTelefoneTag';

/**
 * A tag de um número da fila, com o ⓘ e o tooltip quando o design pede explicação.
 *
 * Existe para o painel lateral e a barra de canal do chat não escreverem a mesma tag duas
 * vezes: as duas telas mostram exatamente o mesmo widget, e é o `Badge` compartilhado por
 * dentro — nenhum pill novo.
 */
export function TelefoneTagBadge(t0) {
  const $ = _c(15);
  const {
    tag
  } = t0;
  let t1;
  if ($[0] !== tag.ajuda) {
    t1 = tag.ajuda ? <span aria-hidden={true}>ⓘ</span> : null;
    $[0] = tag.ajuda;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== tag.label) {
    t2 = <span className="flex items-center gap-1">{tag.label}{t1}</span>;
    $[2] = t1;
    $[3] = tag.label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== tag.variant) {
    t3 = <Badge variant={tag.variant}>{t2}</Badge>;
    $[5] = t2;
    $[6] = tag.variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const badge = t3;
  if (!tag.ajuda) {
    return badge;
  }
  let t4;
  if ($[8] !== tag.ajuda) {
    t4 = [tag.ajuda];
    $[8] = tag.ajuda;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== badge) {
    t5 = <span className="cursor-help">{badge}</span>;
    $[10] = badge;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <TooltipLista itens={t4}>{t5}</TooltipLista>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}